<template>

  <modalo
    :title="tag.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => tag">

    <form
      id="tag-form"
      v-on:submit.prevent="saveTag(tag)">
      <div class="form-group">
        <label>{{ $t('Type') }}</label>
        <div class="form-control">
          {{ tag.type === 'candidate' ? $t('Candidate') : $t('Job') }}
        </div>
        <ValidateMessage :error="validateErrors.type" />
      </div>
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="tag.name" maxlength="30">
        <ValidateMessage :error="validateErrors.name" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="tag-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="tag._id"
          type="button"
          class="btn btn-danger"
          @click="deleteTag(tag)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'TagForm',
  components: {
  },
  props: [
    'initTag'
  ],
  data () {
    return {
      loading: false,
      tag: this.defaultValues(this.initTag),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveTag
    */
    saveTag (data) {
      if (data._id) this.updateTag(data)
      else this.createTag(data)
    },
    /*
    createTag
    */
    createTag (data) {
      this.loading = true

      this.$store
      .dispatch('createTag', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateTag
    */
    updateTag (data) {
      this.loading = true

      this.$store
      .dispatch('updateTag', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteTag (data) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteTag', {
          type: data.type,
          id: data._id
        })
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Tag/TagForm.vue